import Home from '../src/components/Home'

export default function Index() {
  return (
    <div className="cure-inner-container">
      <Home />
    </div>
  )
}
